import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/LoginView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard/DashboardView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard/vant',
    name: 'DashboardVant',
    component: () => import('@/views/Dashboard/DashboardVant.vue'),
    meta: { requiresAuth: true }
  },
  // 临时设计预览路由
  {
    path: '/design/1',
    name: 'Design1',
    component: () => import('@/views/Dashboard/DashboardDesign1-LuxuryMinimalist.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/design/2',
    name: 'Design2',
    component: () => import('@/views/Dashboard/DashboardDesign2-OrganicNatural.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/design/3',
    name: 'Design3',
    component: () => import('@/views/Dashboard/DashboardDesign3-BrutalistIndustrial.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/design/4',
    name: 'Design4',
    component: () => import('@/views/Dashboard/DashboardDesign4-RetroVintage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/design/5',
    name: 'Design5',
    component: () => import('@/views/Dashboard/DashboardDesign5-PlayfulPremium.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/designs',
    name: 'Designs',
    component: () => import('@/views/Dashboard/DesignPreview.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/create',
    name: 'Create',
    component: () => import('@/views/Create/CreateView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/receipts/query',
    name: 'ReceiptsQuery',
    component: () => import('@/views/Receipts/ReceiptsQueryView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/receipt/:id',
    name: 'Receipt',
    component: () => import('@/views/Receipt/ReceiptView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/success/:id',
    name: 'Success',
    component: () => import('@/views/Success/SuccessView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/performance',
    name: 'Performance',
    component: () => import('@/views/Performance/PerformanceView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/students',
    name: 'Students',
    component: () => import('@/views/Students/StudentsListView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/students/:id',
    name: 'StudentDetail',
    component: () => import('@/views/Students/StudentDetailView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/generator',
    name: 'Generator',
    component: () => import('@/components/ReceiptGeneratorFull.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/receipts/public/query',
    name: 'ReceiptPublicQuery',
    component: () => import('@/views/Receipts/ReceiptPublicQueryView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFoundView.vue'),
    meta: { requiresAuth: false }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 路由守卫
router.beforeEach((to, from) => {
  const authStore = useAuthStore()

  // 检查认证状态
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    return { path: '/login' }
  } else if (to.path === '/login' && authStore.isAuthenticated) {
    // 登录后直接跳转到dashboard
    return { path: '/dashboard' }
  } else if (to.path === '/' || to.path === '/home') {
    // 根路径或home路径统一跳转到dashboard
    return { path: '/dashboard' }
  } else {
    return true
  }
})

export default router
